import React from 'react';

import SCHOOL_IMAGE from 'images/school.png';
import CLASS_IMAGE from 'images/class.png';
import CardMedia from '@mui/material/CardMedia';

type ReportType = 'organization' | 'class';

interface ReportHeaderProps {
    type: ReportType;
    // Organization report props
    schoolName?: string;
    // Class report props
    className?: string;
    teacherName?: string;
    // Common props
    startDate?: string;
    endDate?: string;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({ 
    type,
    schoolName,
    className,
    teacherName,
    startDate,
    endDate
}) => {
    const formatDateRange = (start?: string, end?: string) => {
        if (!start || !end) return '';
        return `${start} — ${end}`;
    };

    const getImage = () => {
        return type === 'organization' ? SCHOOL_IMAGE : CLASS_IMAGE;
    };

    const getHeaderClassName = () => {
        return type === 'organization' ? 'header organization-header' : 'header class-header';
    };

    return (
        <div className={getHeaderClassName()}>
            <div className="content">
                <div className="report-info">
                    <div className="report-title">
                        {type === 'organization' ? 'Funexpected Math School Report' : 'Funexpected Math Class Report'}
                    </div>
                    <div className="report-subtitle">
                        {type === 'organization' ? (
                            <span>{schoolName}</span>
                        ) : (
                            <span>
                                <span style={{ fontWeight: 'normal' }}>Class:</span> <strong>{className}</strong>
                                <span style={{ marginLeft: '24px' }}>
                                    <span style={{ fontWeight: 'normal' }}>Educator:</span> <strong>{teacherName}</strong>
                                </span>
                            </span>
                        )}
                    </div>
                    {(startDate && endDate) && (
                        <div className="date-badge">
                            {formatDateRange(startDate, endDate)}
                        </div>
                    )}
                </div>
                <div className="characters">
                    <CardMedia
                        component="img"
                        sx={{maxWidth: 500, maxHeight: 500, objectFit: 'cover'}}
                        image={getImage()}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReportHeader;
export type { ReportType };